import template from './lodgement.template.html';
import templateConfirm from './confirmDialog.template.html';
import templateErrors from './lodgementErrors.template.html';
import templateSocietyOne from './societyOne.template.html';
import templateWestpacNZ from './westpacNZDocuments.template.html';

export default {
  template,
  bindings: {
    idTicket: '<',
    documents: '<',
    lender: '<',
    homeLoan: '<',
    objectives: '<',
    feesAndCharges: '<',
    compareProducts: '<',
    availableLenders: '<',
    workflowType: '<',
    currentAssetFinance: '<',
    currentTicketOwner: '<',
    attachmentsCompliance: '<',
    availableFileLabels: '<',
    isCommercial: '<',
    isTicketSettled: '<',
    contacts: '<',
    ticket: '<',
    ticketOwner: '<',
    onFinished: '&',
    onGatewaySelected: '&',
    onValidated: '&'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor(
      $window,
      $mdDialog,
      $rootScope,
      lodgementsService,
      lodgementService,
      homeLoanService,
      assetFinanceService,
      uiService,
      dateTimeService,
      helperService,
      eventService,
      LODGEMENT
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.isReady = null;
      ctrl.isApplicationLoading = null;
      ctrl.isUpdateApplicationLoading = null;
      ctrl.showSelectGatewaySection = null;
      ctrl.gateways = _.filter(lodgementsService.getGateways() || [], 'isActive');
      ctrl.gateway = null;
      ctrl.application = null;
      ctrl.url = null;
      ctrl.applicationOpen = null;
      ctrl.minimumFieldsErrors = [];
      ctrl.societyOneModel = {};
      ctrl.westpacNZDocuments = null;
      ctrl.isNmb = $rootScope.isNmb();
      ctrl.isDev = $rootScope.isDev();
      ctrl.moneyPlace = { covid: { impact: ['no impact'], wfh: 'false' } };
      ctrl.moneyPlaceOptions = {
        covid: {
          impact: [
            { id: 'no impact', title: 'No impact' },
            { id: 'reduced income', title: 'Reduced income' },
            { id: 'reduced hours', title: 'Reduced hours' },
            { id: 'reduced rental income', title: 'Reduced rental income' },
            { id: 'stood down', title: 'Stood down' },
            { id: 'made redundant', title: 'Made redundant' },
            { id: 'partner/dependant impacted', title: 'Partner/Dependant impacted' }
          ],
          wfh: [
            { id: 'true', title: 'Working from home' },
            { id: 'false', title: 'Not working from home' }
          ]
        }
      };
      ctrl.response = null;

      ctrl.initialize = () => {
        ctrl.documents = ctrl.documents || [];
        ctrl.ticketOwner = ctrl.ticketOwner || {};

        ctrl.filteredGateways = ctrl.gateways.filter(
          (gateway) =>
            gateway.workflowType.includes(ctrl.workflowType) &&
            ctrl.isLenderSupported(gateway.type)
        );

        ctrl.isLoanworks = lodgementsService.gateways.loanworks.isLenderSupported({
          id: ctrl.getLender().id
        });

        if (ctrl.isLoanworks) {
          ctrl.gateway = lodgementsService.gateways.loanworks;
          ctrl.isValidatedLoanworks = ctrl.hasGatewayAnyErrors();
          ctrl.onGatewaySelected({ gateway: ctrl.gateway });

          ctrl.accreditation = _.find(
            ctrl.currentTicketOwner.lenderAccreditations,
            (val) => val.idLender === ctrl.getLender().id
          );

          const errors = ctrl.gateway?.isMinimumFieldsFilled({
            accreditation: ctrl.accreditation,
            contacts: [].concat(ctrl.contacts),
            currentTicketOwner: ctrl.currentTicketOwner,
            securitySplits: ctrl.homeLoan?.securityDetails?.securitySplits || [],
            reviewProducts: ctrl.homeLoan?.reviewProducts || [],
            loan: ctrl.homeLoan || ctrl.currentAssetFinance,
            ticket: ctrl.ticket
          });

          ctrl.onValidated({ validationErrors: errors?.validationErrors || [] });
        }

        ctrl.loadLodgedApplication();
      };

      ctrl.selectGateway = (gateway) => {
        ctrl.gateway = gateway;

        if (ctrl.hasGatewayAnyErrors()) {
          ctrl.showError();
        } else {
          ctrl.showSelectGatewaySection = false;
        }
        ctrl.onGatewaySelected({ gateway: ctrl.gateway });
      };

      ctrl.loadLodgedApplication = async () => {
        lodgementsService.clearCache();

        ctrl.application = await lodgementsService.loadApplication(ctrl.idTicket);

        if (ctrl.applicationExist()) {
          ctrl.gateway = _.find(ctrl.gateways, ({ type }) => ctrl.application.type === type);
          ctrl.isGatewayAnyErrors = ctrl.hasGatewayAnyErrors();
        } else {
          ctrl.showSelectGatewaySection = true;
        }

        if (ctrl.isOpenHardcodedLoginUrl()) {
          ctrl.url = ctrl.gateway.loginUrl;
        }

        ctrl.isReady = true;
      };

      ctrl.showConfirmDialog = (isLenderChanged) =>
        $mdDialog.show({
          template: templateConfirm,
          controllerAs: '$ctrl',
          controller() {
            const self = this;
            self.messages = [];

            self.header = isLenderChanged
              ? 'Lender has been changed'
              : 'Are you sure? Updating application will overwrite previously entered details.';

            self.text = isLenderChanged
              ? `This will create new application in ${ctrl.gateway.value} and will link this ticket to new application. Old application will be unlinked from this ticket. Are you sure you want to proceed?`
              : 'Are you sure you want to update application?';

            self.isUpdateDisabled =
              ctrl.getApplicationIdLender() ===
                '6029ad56d2c6c0f7726d837bcec2c83253e29516d5923e232431215f3a380e3f' &&
              !isLenderChanged &&
              ctrl.gateway.type === 'simpology';

            if (self.isUpdateDisabled) {
              self.header = 'Update is not available for this Lender.';
              self.text = '';
            }
            self.messages.push(self.header, self.text);

            self.confirm = () => {
              $mdDialog.hide(true);
            };
            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });

      ctrl.isOpenHardcodedLoginUrl = () => ctrl.applicationExist() && ctrl.gateway.loginUrl;

      ctrl.openApplication = (isUpdate) => {
        if (ctrl.isOpenHardcodedLoginUrl()) {
          const url =
            ctrl.gateway.type === 'moneyPlace'
              ? `${ctrl.gateway.loginUrl}${ctrl.application.lenderAssignedId}`
              : ctrl.gateway.loginUrl;
          $window.open(url, '_blank', '');
          ctrl.hideLoading(isUpdate);
          return;
        }

        if (ctrl.url || ctrl.urlUpdate) {
          if (isUpdate) {
            $window.open(ctrl.urlUpdate, '_blank', '');
            ctrl.urlUpdate = '';
          } else {
            $window.open(ctrl.url, '_blank', '');
            ctrl.url = '';
          }
        } else if (isUpdate) {
          if (ctrl.hasGatewayAnyErrors()) {
            ctrl.showError();
          } else {
            ctrl.showConfirmDialog(ctrl.isLenderChanged()).then((result) => {
              if (result) {
                ctrl.sendApplication(true).then(ctrl.handleResponse(isUpdate));
              }
            });
          }
        } else {
          ctrl.sendApplication(false).then(ctrl.handleResponse(isUpdate));
        }
      };

      ctrl.showLoading = (isUpdate) => {
        if (isUpdate) {
          ctrl.isUpdateApplicationLoading = true;
        } else {
          ctrl.isApplicationLoading = true;
        }
      };

      ctrl.hideLoading = (isUpdate) => {
        if (isUpdate) {
          ctrl.isUpdateApplicationLoading = false;
        } else {
          ctrl.isApplicationLoading = false;
        }
      };

      ctrl.handleResponse = (isUpdate) => (result) => {
        ctrl.response = result;
        ctrl.showErrorsResponse = !ctrl.response.status;

        ctrl.hideLoading(isUpdate);

        if (result?.status) {
          if (isUpdate) {
            ctrl.urlUpdate = result.url;
          } else {
            ctrl.url = result.url;
          }
          ctrl.loadLodgedApplication();

          uiService.toast({
            text: {
              p1: 'Application',
              p2: 'successfully',
              p3: 'lodged...'
            },
            success: true
          });
        }
        if (!result?.status) {
          if (
            ctrl.gateway.workflowType.includes('asset_finance') ||
            ctrl.isWestpacNZGatewaySelected()
          ) {
            const alert = helperService.errorsAlert({
              errors: ctrl.response?.errors || [],
              errorMessage: ctrl.response?.errorMessage || '',
              title: ctrl.gateway?.value
            });
            eventService.alertDialog({ alert });
          } else {
            uiService.toast({
              text: {
                p1: 'Error',
                p2: 'happened',
                p3: result.message
              },
              warn: true
            });
          }
        }
      };

      ctrl.sendApplication = (isUpdate) => {
        ctrl.showLoading(isUpdate);
        if (ctrl.isWestpacNZGatewaySelected()) {
          return ctrl.gateway.sendApplication({
            idTicket: ctrl.idTicket,
            attachments: ctrl.westpacNZDocuments
          });
        }
        if (ctrl.isSocietyOneGatewaySelected()) {
          return ctrl.gateway.sendApplication({
            idTicket: ctrl.idTicket,
            loanPurpose: ctrl.societyOneModel?.loanPurpose || '',
            privacyDisclosureStatement: ctrl.societyOneModel?.privacyDisclosureStatement || '',
            electronicCommunicationConsent:
              ctrl.societyOneModel?.electronicCommunicationConsent || '',
            creditCheckConsent: ctrl.societyOneModel?.creditCheckConsent || ''
          });
        }
        if (ctrl.isMoneyPlaceAssetFinanceGatewaySelected()) {
          return ctrl.gateway.sendApplication({
            idTicket: ctrl.idTicket,
            covid: ctrl.moneyPlace.covid
          });
        }
        return ctrl.gateway.sendApplication({
          idTicket: ctrl.idTicket,
          isLenderChanged: isUpdate && ctrl.isLenderChanged(),
          isOpenExisting: !isUpdate && ctrl.applicationExist()
        });
      };

      ctrl.hasGatewayAnyErrors = () =>
        !(
          ctrl.getPreferredProduct() &&
          ctrl.isMinimumFieldsFilled() &&
          ctrl.isLenderSupported(ctrl.gateway?.type) &&
          ctrl.hasOwnerGatewayAccreditation() &&
          ctrl.areAllRequiredComplianceFieldsFilled() &&
          ctrl.areAllRequiredComplianceDocumentsAdded() &&
          ctrl.hasBasisForRecommendationFilled()
        );

      ctrl.isMinimumFieldsFilled = () => {
        ctrl.minimumFieldsErrors = [];
        const accreditation = _.find(
          ctrl.currentTicketOwner.lenderAccreditations,
          (val) => val.idLender === ctrl.getLender().id
        );

        const errors = ctrl.gateway?.isMinimumFieldsFilled({
          accreditation,
          contacts: [].concat(ctrl.contacts),
          currentTicketOwner: ctrl.currentTicketOwner,
          securitySplits: ctrl.homeLoan?.securityDetails?.securitySplits || [],
          reviewProducts: ctrl.homeLoan?.reviewProducts || [],
          loan: ctrl.homeLoan || ctrl.currentAssetFinance,
          ticket: ctrl.ticket
        });

        ctrl.minimumFieldsErrors = errors?.validationErrorMessages || [];
        if (ctrl.minimumFieldsErrors.length) {
          ctrl.minimumFieldsErrors.unshift('Some of required minimum fields are not filled:');
        }
        ctrl.onGatewaySelected({ gateway: ctrl.gateway });
        ctrl.onValidated({ validationErrors: errors?.validationErrors || [] });
        return !ctrl.minimumFieldsErrors.length;
      };

      ctrl.areAllRequiredComplianceFieldsFilled = () => {
        if (ctrl.workflowType === 'home_loan') {
          return helperService.getStatusOfRequiredComplianceFields({
            products: ctrl.homeLoan?.reviewProducts || [],
            compliance: ctrl.homeLoan?.compliance || {},
            objectives: ctrl.objectives || {},
            hasHomeLoanTools: true,
            idPreferredLender: ctrl.getPreferredProduct()?.idLender || ''
          });
        }

        if (ctrl.workflowType === 'asset_finance') {
          return helperService.getStatusOfRequiredComplianceFields({
            products: ctrl.currentAssetFinance?.compareProducts || [],
            compliance: ctrl.currentAssetFinance?.compliance || {},
            objectives: ctrl?.objectives || {},
            isCommercial: ctrl.currentAssetFinance?.isCommercial || false,
            hasAssetFinanceTools: true
          });
        }

        return true;
      };

      ctrl.areAllRequiredComplianceDocumentsAdded = () => {
        const isNz = helperService.getOrganizationCountry().cca2 === 'NZ';
        if (isNz) {
          return true;
        }

        if (ctrl.workflowType === 'home_loan') {
          return homeLoanService.areAllRequiredComplianceDocumentsAdded(
            ctrl.attachmentsCompliance,
            ctrl.availableFileLabels
          );
        }

        if (ctrl.workflowType === 'asset_finance' && !ctrl.currentAssetFinance.isCommercial) {
          return homeLoanService.areAllRequiredComplianceDocumentsAdded(
            ctrl.attachmentsCompliance,
            ctrl.availableFileLabels
          );
        }

        return true;
      };

      ctrl.isLenderSupported = (gatewayType) => {
        const { id, uuid, gateway } = ctrl.getLender();
        const preferredProduct = ctrl.getPreferredProduct();

        if (!id || !gatewayType) {
          return false;
        }

        return ctrl.gateways
          .find(({ type }) => type === gatewayType)
          .isLenderSupported(
            {
              id,
              gateway,
              uuid
            },
            ctrl.currentAssetFinance?.financeProposal?.productType,
            preferredProduct
          );
      };

      ctrl.hasOwnerGatewayAccreditation = () =>
        ctrl.gateway.hasOwnerGatewayAccreditation({
          currentTicketOwner: ctrl.currentTicketOwner
        });

      ctrl.hasBasisForRecommendationFilled = () => {
        if (ctrl.workflowType === 'home_loan') return true;

        if (ctrl.workflowType === 'asset_finance') {
          if (ctrl?.isCommercial) return true;
          return assetFinanceService.hasBasisForRecommendationFilled(ctrl.currentAssetFinance);
        }

        return true;
      };

      ctrl.showError = () => {
        $mdDialog.show({
          locals: {
            isAstute: ctrl.isAstute,
            gateway: ctrl.gateway,
            isPreferredProductSelected: ctrl.getPreferredProduct(),
            isMinimumFieldsFilled: ctrl.isMinimumFieldsFilled(),
            minimumFieldsErrors: ctrl.minimumFieldsErrors,
            isLenderSupported: ctrl.isLenderSupported(ctrl.gateway?.type),
            hasOwnerGatewayAccreditation: ctrl.hasOwnerGatewayAccreditation(),
            areAllRequiredComplianceFieldsFilled: ctrl.areAllRequiredComplianceFieldsFilled(),
            areAllRequiredComplianceDocumentsAdded:
              ctrl.areAllRequiredComplianceDocumentsAdded(),
            hasBasisForRecommendationFilled: ctrl.hasBasisForRecommendationFilled(),
            compliance:
              ctrl.workflowType === 'asset_finance' ? ctrl.currentAssetFinance?.compliance : {}
          },
          template: templateErrors,
          clickOutsideToClose: true,
          controllerAs: '$ctrl',
          controller(
            isAstute,
            gateway,
            isPreferredProductSelected,
            isMinimumFieldsFilled,
            minimumFieldsErrors,
            isLenderSupported,
            hasOwnerGatewayAccreditation,
            areAllRequiredComplianceFieldsFilled,
            areAllRequiredComplianceDocumentsAdded,
            hasBasisForRecommendationFilled,
            compliance
          ) {
            const self = this;
            self.isAstute = isAstute;
            self.gateway = gateway;
            self.isPreferredProductSelected = isPreferredProductSelected;
            self.isMinimumFieldsFilled = isMinimumFieldsFilled;
            self.minimumFieldsErrors = minimumFieldsErrors;
            self.isLenderSupported = isLenderSupported;
            self.hasOwnerGatewayAccreditation = hasOwnerGatewayAccreditation;
            self.areAllRequiredComplianceFieldsFilled = areAllRequiredComplianceFieldsFilled;
            self.areAllRequiredComplianceDocumentsAdded =
              areAllRequiredComplianceDocumentsAdded;
            self.hasBasisForRecommendationFilled = hasBasisForRecommendationFilled;
            self.compliance = compliance;

            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });
      };

      ctrl.getPreferredProduct = () => {
        if (ctrl.workflowType === 'home_loan') {
          return homeLoanService.getPreferredProduct(ctrl.compareProducts);
        }
        if (ctrl.workflowType === 'asset_finance') {
          const preferredProduct = assetFinanceService.getPreferredProduct(
            ctrl.compareProducts
          );
          return preferredProduct ? preferredProduct.selectedProduct : '';
        }
        return null;
      };

      ctrl.getLender = () => {
        let lender;
        const preferredProduct = ctrl.getPreferredProduct();
        if (ctrl.workflowType === 'home_loan') {
          if (preferredProduct) {
            lender = ctrl.availableLenders.find((l) => l.id === preferredProduct.idLender);
          }
        } else if (ctrl.workflowType === 'asset_finance') {
          if (preferredProduct) {
            lender = ctrl.availableLenders.find((l) => l.id === preferredProduct.lender[0].id);
          }
        }

        return lender || {};
      };

      ctrl.getApplicationLender = () => {
        const applicationIdLender = ctrl.getApplicationIdLender();
        const lender = ctrl.availableLenders.find((l) => l.id && l.id === applicationIdLender);
        return lender || {};
      };
      ctrl.isSimpologyTestBank = () => {
        if (ctrl.gateway?.type !== 'simpology') {
          return false;
        }
        const { gateway } = ctrl.getLender();
        return lodgementService.isSimpologyTestBank(gateway);
      };

      ctrl.isMacquarieAssetFinanceGatewaySelected = () => {
        const lender = ctrl.getLender();
        return (
          ctrl.gateway?.type === 'macquarieassetfinance' &&
          lender?.id === 'afee27132d1ff1ae3a56aa4518b99ed6'
        );
      };

      ctrl.isMoneyPlaceAssetFinanceGatewaySelected = () => {
        const lender = ctrl.getLender();
        return (
          ctrl.gateway?.type === 'moneyPlace' &&
          lender?.id === '88fa70c1ffe803e86abda8b0058a202ce8313c05367249c5dab33639205572a7'
        );
      };

      ctrl.isWestpacNZGatewaySelected = () => {
        const lender = ctrl.getLender();
        return (
          ctrl.gateway?.type === 'westpacNZ' &&
          lender?.id === '460c97355b421b53d39c06cc35dd36f5'
        );
      };

      ctrl.isSocietyOneGatewaySelected = () => {
        const lender = ctrl.getLender();
        return (
          ctrl.gateway?.type === 'societyOne' &&
          lender?.id === '58ec614ca97827e31f6156fff802c499f4a71d7ff5ad843a56ae9691b48cac0c'
        );
      };

      ctrl.sendDocumentsToMacquarieAssetFinance = (selectedDocuments) => {
        uiService.toast({
          text: {
            p1: 'Sending documents',
            p2: 'is in progress',
            p3: 'please wait'
          },
          progress: true,
          delay: 2000
        });
        lodgementService
          .macquarieAssetFinanceSendDocuments({
            idTicket: ctrl.idTicket,
            documents: selectedDocuments
          })
          .then((res) => {
            if (res?.status) {
              uiService.toast({
                text: {
                  p1: selectedDocuments?.length > 1 ? 'Documents' : 'Document',
                  p2: selectedDocuments?.length > 1 ? 'have been' : 'has been',
                  p3: 'sent'
                },
                success: true
              });
            } else {
              const alert = helperService.errorsAlert({
                errors: res?.errors || [],
                errorMessage: res?.errorMessage || '',
                title: ctrl.gateway?.value
              });
              eventService.alertDialog({ alert });
            }
          });
      };

      ctrl.showSendDocuments = () => {
        if (!ctrl.application?.lenderAssignedId) return false;

        const lender = ctrl.getApplicationLender();

        const emailForSupportingDocuments = _.filter(
          lender.contact,
          ({ type, details }) => type === 'EMAIL_FOR_SUPPORTING_DOCUMENT' && details
        );

        return emailForSupportingDocuments.length;
      };

      ctrl.societyOneSendApplication = ($event) => {
        $event.stopPropagation();
        if (ctrl.url) {
          $window.open(ctrl.url, '_blank', '');
        } else {
          ctrl.isApplicationLoading = true;
          $mdDialog
            .show({
              targetEvent: $event,
              template: templateSocietyOne,
              controllerAs: '$ctrl',
              controller() {
                const self = this;
                self.availableLoanPurposes = LODGEMENT.SOCIETY_ONE.LOAN_PURPOSES;
                self.societyOne = {
                  loanPurpose: '',
                  privacyDisclosureStatement: false,
                  electronicCommunicationConsent: false,
                  creditCheckConsent: false
                };

                self.canSend = () =>
                  self.societyOne.loanPurpose !== '' &&
                  self.societyOne.privacyDisclosureStatement &&
                  self.societyOne.electronicCommunicationConsent &&
                  self.societyOne.creditCheckConsent;

                self.confirm = () => {
                  if (self.canSend()) {
                    $mdDialog.hide(self.societyOne);
                  }
                };
                self.cancel = () => {
                  $mdDialog.hide(null);
                };
              }
            })
            .then((result) => {
              if (result) {
                ctrl.societyOneModel = result;
                ctrl.sendApplication(false).then(ctrl.handleResponse(false));
              } else {
                ctrl.isApplicationLoading = false;
              }
            });
        }
      };

      ctrl.moneyPlaceSendApplication = ($event) => {
        $event.stopPropagation();
        if (ctrl.url) {
          $window.open(ctrl.url, '_blank', '');
        } else {
          ctrl.isApplicationLoading = true;
          $mdDialog
            .show({
              targetEvent: $event,
              template: templateSocietyOne,
              controllerAs: '$ctrl',
              controller() {
                const self = this;
                self.availableLoanPurposes = LODGEMENT.SOCIETY_ONE.LOAN_PURPOSES;
                self.societyOne = {
                  loanPurpose: '',
                  privacyDisclosureStatement: false,
                  electronicCommunicationConsent: false,
                  creditCheckConsent: false
                };

                self.canSend = () =>
                  self.societyOne.loanPurpose !== '' &&
                  self.societyOne.privacyDisclosureStatement &&
                  self.societyOne.electronicCommunicationConsent &&
                  self.societyOne.creditCheckConsent;

                self.confirm = () => {
                  if (self.canSend()) {
                    $mdDialog.hide(self.societyOne);
                  }
                };
                self.cancel = () => {
                  $mdDialog.hide(null);
                };
              }
            })
            .then((result) => {
              if (result) {
                ctrl.societyOneModel = result;
                ctrl.sendApplication(false).then(ctrl.handleResponse(false));
              } else {
                ctrl.isApplicationLoading = false;
              }
            });
        }
      };

      ctrl.westpacNZSendApplication = ($event) => {
        $event.stopPropagation();
        ctrl.isApplicationLoading = true;
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              documents: ctrl.documents
            },
            template: templateWestpacNZ,
            controllerAs: '$ctrl',
            controller(documents) {
              const self = this;
              self.documents = documents;
              self.selectedDocuments = [];
              self.limit = 8;
              self.showMoreDocuments = false;

              _.forEach(self.documents, (d) => {
                const doc = d;
                doc.isSelected = false;
                return doc;
              });

              self.select = ({ document }) => {
                const file = document;
                file.isSelected = !file.isSelected;
                const idx = _.findIndex(self.selectedDocuments, (d) => d?.id === file?.id);
                if (idx === -1) {
                  self.selectedDocuments.push(file);
                } else {
                  ctrl.selectedDocuments.splice(idx, 1);
                }
              };

              self.toggleShowMore = () => {
                self.showMoreDocuments = !self.showMoreDocuments;
                self.limit = self.showMoreDocuments ? undefined : 8;
              };

              self.confirm = () => {
                if (self.selectedDocuments?.length) {
                  $mdDialog.hide(self.selectedDocuments);
                }
              };
              self.cancel = () => {
                $mdDialog.hide(null);
              };
            }
          })
          .then((result) => {
            if (result?.length) {
              ctrl.westpacNZDocuments = result;
              ctrl.sendApplication(false).then(ctrl.handleResponse(false));
            } else {
              ctrl.isApplicationLoading = false;
            }
          });
      };

      ctrl.applicationExist = () => !!ctrl.application;

      ctrl.isAstute = () => $rootScope.isAstuteOrg();

      ctrl.getApplicationIdLender = () => ctrl.application && ctrl.application.idLender;

      ctrl.isLenderChanged = () =>
        ctrl.applicationExist() ? ctrl.getLender().id !== ctrl.getApplicationIdLender() : false;

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
